import React, {useState, useRef, useLayoutEffect} from 'react';
import styles from './styles';
import IncrementForms from '../IncrementForms';
import formSchema from './formSchema';
import parentStyles from '../styles';
import config from '../../../../config/axios.config';
import axios from 'axios';
import {UserContext} from "../../../../Context/UserContext";
import {IconTextButton} from '@xpertdox_js/xdcomponents';
import {InstanceContext} from "../../../../InstanceContext";
import {btn_c_xdHighlight} from '@xpertdox_js/xdstyle';
import { trackError } from '../../../../utils/activityTracker'

const StudyLocationsDropdown = props => {

  const [forms, setForms] = useState({});
  const [error, setError] = useState(false);
  const { user, userAction } = React.useContext(UserContext);
  const {contextInstance} = React.useContext(InstanceContext);


  const handleSave = () => {
    const url = `${config.apiUrl}/rt/console/saveFacilities/${contextInstance || user.instance}/${user.email}`;
    let hasDuplicateFacility = false;
    const facilitiesNames = [];
    const body = {
      facilities: Object.values(forms).map(form => {
        let value = {};
        form.forEach(obj => {
          value[obj.id] = obj.value;
        })
        if (facilitiesNames.includes(value.name)) {
          hasDuplicateFacility = true;
        }
        facilitiesNames.push(value.name)
        return value;
      }),
      trial: props.data.nct
    }
    console.log(body);
    if (hasDuplicateFacility) {
      setError('Duplicate location entries are not allowed.');
      return;
    } else if (error) {
      setError(false);
    }
    axios.post(url, body).then(() => {
      props.dataRefresh('locations')
    }).catch(err => {
      console.log(err, "ERR")
      trackError({ error: err, history: props.history })
      if (err && err.response && err.response.status === 403) {
        userAction({type: 'logout'})
      }
    })
  }

  // layout trackker
  const elemRef = useRef();
  useLayoutEffect(() => {
    if (elemRef.current) {
      props.measureCallback(elemRef.current)
    }
  }, [forms])

  return(
      <div style={parentStyles.container} ref={elemRef}>
        <IncrementForms
          key='pi'
          values={props.data && props.data.facilities ? props.data.facilities : []}
          forms={forms}
          setForms={setForms}
          formSchema={formSchema}
        />
        <div style={styles.saveBtnContainer}>
          <IconTextButton
            size='md'
            icon='save'
            preBuiltStyles={btn_c_xdHighlight}
            onClick={handleSave}
            text='Save Changes'
          />
          {error && <div style={parentStyles.errorMsg}>{error}</div>}
        </div>
      </div>
  )
}

export default StudyLocationsDropdown;
